import { svelteHelpers } from "@propublica/pp-frontend";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import * as components from "./svelte-components.js";

// @ts-ignore (TODO(@alecglassford): Fix type problems with components)
svelteHelpers.hydrateAllComponentsOnPage(components);

// Add your code here! (or write other JS modules and use their imports here)

document.documentElement.classList.add("p-force-dark-mode");
gsap.registerPlugin(ScrollTrigger);

const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
const isChrome = /CriOS/.test(navigator.userAgent);

if (isIOS && !isChrome) {
  ScrollTrigger.normalizeScroll(true);
}

if (/FxiOS/.test(navigator.userAgent)) {
  ScrollTrigger.normalizeScroll(true);
}

const hedMaskTl = gsap.timeline({
    scrollTrigger: {
        trigger: ".p-custom-opener-hed-container",
        start: "top 15%",
        end: "bottom 30%",
        scrub: 2,
        //markers: true,
    }
});

hedMaskTl
    .to(".hed-wave", { height: 60, ease: "power2.out", duration: 0.5 }, 0)
    .to(".hed-mask", { height: "100%", ease: "none", duration: 10 }, 0);

const mm = gsap.matchMedia();

// DESKTOP // 

        mm.add("(min-width: 48em)", () => {

            // PUMPJACK SCENE //

            const slide1Clouds = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-01",
                    start: "center 30%",
                    endTrigger: ".intro-slide--text-02",
                    end: "top 70%",
                    scrub: 1,
               
          
                }
            });
          
            slide1Clouds.to("#intro-1-clouds", { opacity: 1, duration: 2 })
            .to(["#intro-1-jack", "#intro-1-bg"], { opacity: 1, duration: 4 }); 



            // UNIVERSITY GATES //

            const slide2Gate = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-02",
                    start: "top 70%",
                    endTrigger: ".intro-slide--text-03",
                    end: "top 70%",
                    scrub: 1,
                 
                }
            })

            slide2Gate.to(["#intro-2-gate", "#intro-2-bg"], {opacity: 1, duration: 5})
                .to("#intro-1-bg", {opacity:0})
                .to(["#intro-2-gate", "#intro-2-bg"], {scale: 1.25, duration: 6, ease: "power1.in"})
                .to(".intro-image--01", {opacity:0}, "<")
                .to("#intro-2-school", {opacity: 1, duration: 2}, "<+=0.5")
                 .to("#intro-2-vines", {opacity: 1, duration: 2, scale: 1})
                .to("#intro-2-gate", {opacity: 0, duration: 2}, "<+=0.5")
                .to("#intro-2-school", {duration: 4, ease: "power1.in"}, "<")
                .to(".intro-image--02", {opacity: 0, duration: 4});


            // LAB //

            const slide2Lab = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-03",
                    start: "top 70%",
                    endTrigger: ".intro-slide--text-04", 
                    end: "top 70%",
                    scrub: 1,
                }
            });

            slide2Lab
                .to("#intro-2-hall", {opacity: 1, duration: 1, scale: 1})
                .to("#intro-2-lab", {opacity: 1, duration: 1, scale: 1})
                .to("#intro-2-lab", {duration: 2})

            // DESK //

            const slide3Desk = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-04",
                    start: "top 70%",
                    endTrigger: ".intro-slide--text-05", 
                    end: "top 70%",
                    scrub: 1,
                }
            });

            slide3Desk.to(".intro-image--03", {opacity: 0})
                .to("#intro-3-desk-1", {opacity: 1})
                .to("#intro-3-desk-2", {opacity:1})
                .to("#intro-3-desk-3", {opacity:1});



            // UN //

            const slide4UN = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-05",
                    start: "top 70%",
                    endTrigger: ".intro-slide--text-06",
                    end: "top 70%",
                    scrub: 1,
                }
            });

            slide4UN.to(".intro-image--04", {opacity:0})
                .to("#intro-4-un-1", {opacity:1})
                .to("#intro-4-un-2", {opacity:1, duration: 3})
             

            // GAS STATION //

            const slide5Gas = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-06",
                    start: "top 70%",
                    end: "bottom bottom",
                    scrub: 1,
                }
            })

            slide5Gas
        
                .to("#intro-5-gas-1", {opacity: 1})
                .to("#intro-5-gas-2", {opacity:1});

    

        });


// MOBILE // 

    mm.add("(max-width: 47.99em)", () => {

        // PUMPJACK SCENE //

            const slide1Clouds = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-01",
                    start: "top center",
                    endTrigger: ".intro-slide--text-02",
                    end: "top 20%",
                    scrub: 1,
                
                }
            });

            slide1Clouds.to("#intro-1-clouds", { opacity: 0.02 }) 

            gsap.to("#intro-1-jack", {
                opacity:1,
                scrollTrigger: {
                    trigger: ".intro-slide--text-01",
                    start: "top 20%",
                    end: "bottom 80%",
                    scrub: 1,
                 
                }
            });

        // UNIVERSITY GATES //

            const slide2Gate = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-02",
                    start: "top bottom",
                    endTrigger: ".intro-slide--text-03",
                    end: "top 70%",
                    scrub: 1,
                }
            })

            slide2Gate.to(["#intro-2-gate", "#intro-2-bg"], {opacity: 1, duration: 2})
                .to(".intro-image--01", {opacity:0, duration: 2}, "<")
                .to("#intro-2-gate", {duration: 1})
                .to("#intro-2-gate", {scale: 1.5, duration: 10, ease: "power1.inOut"})
                .to("#intro-2-school", {opacity: 1, duration: 1}, "<+=0.4")
                .to("#intro-2-gate", {opacity: 0, duration: 3})
                .to(["#intro-2-vines-mobile-left", "#intro-2-vines-mobile-right"], {opacity: 1, duration: 5, scale: 1}, "<+=0.3")
                .to("#intro-2-school", {duration: 6, ease: "power1.inOut"}, "<")
                .to(".intro-image--02", {opacity: 0, duration: 3});



            // LAB //

            const slide2Lab = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-03",
                    start: "top 70%",
                    endTrigger: ".intro-slide--text-04",
                    end: "top 70%",
                    scrub: 1,
                }
            });

            slide2Lab
                .to("#intro-2-hall", {opacity: 1, duration: 3, scale: 1})
                .to("#intro-2-hall", {opacity: 0, duration: 1})
                .to("#intro-2-lab", {opacity: 1, scale: 1, duration: 2}, "<")
                .to(".intro-image--03", {opacity: 0});

   
         // DESK //

            const slide3Desk = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-04",
                    start: "top 70%",
                    endTrigger: ".intro-slide--text-05", 
                    end: "top 70%",
                    scrub: 1,
                }
            });

            slide3Desk
                .to("#intro-3-desk-1", {opacity: 1, duration: 3})
                .to("#intro-3-desk-2", {opacity:1, duration: 2})
                .to("#intro-3-desk-3", {opacity:1, duration: 2})
                .to(".intro-image--04", {opacity: 0, duration: 1});

   
        
            // UN //

            const slide4UN = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-05",
                    start: "top 70%",
                    endTrigger: ".intro-slide--text-06", 
                    end: "top 70%",
                    scrub: 1,
                }
            });

            slide4UN
                .to("#intro-4-un-1", {opacity:1, duration: 1})
                .to("#intro-4-un-2", {opacity:1, duration: 1})

        
                // GAS STATION //

            const slide5Gas = gsap.timeline({
                scrollTrigger: {
                    trigger: ".intro-slide--text-06",
                    start: "top 70%",
                    end: "bottom bottom",
                    scrub: 1,
                }
            })

            slide5Gas

                .to("#intro-5-gas-1", {opacity: 1})
                .to("#intro-5-gas-2", {opacity:1});



            });

// SERIES LIST IMAGE REVEAL //

gsap.utils.toArray(".series-list-img").forEach((/** @type {HTMLElement} */ el) => {
    const mask = document.createElement("div");
    mask.className = "series-img-mask";

    const wave = document.createElement("div");
    wave.className = "series-img-wave";
    mask.appendChild(wave);
    el.appendChild(mask);

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: "top 80%",
            end: "top 30%",
            scrub: 2,
        }
    });

    // Mask shrinks from full height to 0 — reverse of the hed mask animation.
    // Wave fades out in the final 10% so it doesn't linger at the top of the image.
    tl.fromTo(mask, { height: "100%" }, { height: "0%", ease: "none", duration: 10 })
      .fromTo(wave, { height: 60 }, { height: 0, ease: "none", duration: 1 }, "-=1");
});

